"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TablesV3Service", {
    enumerable: true,
    get: function() {
        return TablesV3Service;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
const _columnsservice = require("~/services/columns.service");
const _metadiffsservice = require("~/services/meta-diffs.service");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _apiv3datatransformationbuilder = require("~/utils/api-v3-data-transformation.builder");
const _tablesservice = require("~/services/tables.service");
const _table = require("~/utils/builders/table");
const _helpers = require("~/helpers");
const _columnsv3service = require("~/services/v3/columns-v3.service");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let TablesV3Service = class TablesV3Service {
    async tableUpdate(context, param) {
        (0, _helpers.validatePayload)('swagger-v3.json#/components/schemas/TableUpdate', param.table, true);
        const tableUpdateReq = _extends({}, param.table);
        // if title includes then add table_name as well
        if (tableUpdateReq.title) {
            tableUpdateReq.table_name = tableUpdateReq.title;
        }
        await this.tablesService.tableUpdate(context, {
            tableId: param.tableId,
            table: tableUpdateReq,
            baseId: param.baseId,
            user: param.user,
            req: param.req
        });
        return await this.getTableWithAccessibleViews(context, {
            tableId: param.tableId,
            user: param.user
        });
    }
    async tableDelete(context, param) {
        await this.tablesService.tableDelete(context, param);
        return {};
    }
    async getTableWithAccessibleViews(context, param) {
        var _table_columns_find;
        const table = await this.tablesService.getTableWithAccessibleViews(context, param);
        const result = (0, _table.tableReadBuilder)().build(table);
        const viewBuilder = (0, _table.tableViewBuilder)();
        result.views = table.views.map((view)=>{
            return viewBuilder.build(view);
        });
        result.display_field_id = (_table_columns_find = table.columns.find((column)=>column.pv)) == null ? void 0 : _table_columns_find.id;
        result.fields = table.columns.filter((c)=>!c.system || c.uidt === _nocodbsdk.UITypes.ID).map((column)=>{
            return (0, _apiv3datatransformationbuilder.columnBuilder)().build(column);
        });
        return result;
    }
    async getAccessibleTables(context, param) {
        var _find, _this;
        const tables = await this.tablesService.getAccessibleTables(context, param);
        const metaSourceId = (_this = await _models.Base.get(context, param.baseId).then((base)=>base == null ? void 0 : base.getSources())) == null ? void 0 : (_find = _this.find((source)=>source.isMeta)) == null ? void 0 : _find.id;
        return (0, _table.tableReadBuilder)().build(tables.map((table)=>{
            // exclude source_id for tables from meta source
            if (metaSourceId && table.source_id === metaSourceId) {
                table.source_id = undefined;
            }
            return table;
        }));
    }
    async tableCreate(context, param) {
        let tableCreateOutput;
        try {
            var _param_table_fields;
            (0, _helpers.validatePayload)('swagger-v3.json#/components/schemas/TableCreate', param.table, true, context);
            const columns = [];
            const virtualColumns = [];
            for (const field of (_param_table_fields = param.table.fields) != null ? _param_table_fields : []){
                (0, _helpers.validatePayload)(`swagger-v3.json#/components/schemas/FieldOptions/${field.type}`, field, true, context);
                if ((0, _nocodbsdk.isVirtualCol)(field.type)) {
                    virtualColumns.push(field);
                } else {
                    columns.push(field);
                }
            }
            const tableCreateReq = param.table;
            // remap the columns if provided
            if (columns.length) {
                tableCreateReq.columns = (0, _apiv3datatransformationbuilder.columnV3ToV2Builder)().build(columns);
            } else {
                tableCreateReq.columns = [];
            }
            tableCreateOutput = await this.tablesService.tableCreate(context, {
                baseId: param.baseId,
                table: tableCreateReq,
                user: param.user,
                req: param.req,
                apiVersion: _nocodbsdk.NcApiVersion.V3,
                sourceId: param.sourceId
            });
            // create virtual columns after table creation
            for (const vCol of virtualColumns){
                await this.columnsV3Service.columnAdd(context, {
                    tableId: tableCreateOutput.id,
                    column: vCol,
                    req: param.req,
                    user: param.user
                });
            }
            return this.getTableWithAccessibleViews(context, {
                tableId: tableCreateOutput.id,
                user: param.user
            });
        } catch (e) {
            // if table already created, delete it to avoid orphaned tables
            // this is to handle virtual column creation failures
            if (tableCreateOutput == null ? void 0 : tableCreateOutput.id) {
                this.tablesService.tableDelete(context, {
                    tableId: tableCreateOutput.id,
                    user: param.user,
                    forceDeleteRelations: true,
                    req: param.req
                }).catch((deleteError)=>{
                    this.logger.error(`Failed to cleanup table with id ${tableCreateOutput == null ? void 0 : tableCreateOutput.id} after failed creation`, deleteError);
                });
            }
            throw e;
        }
    }
    constructor(metaDiffService, appHooksService, columnsService, tablesService, columnsV3Service){
        this.metaDiffService = metaDiffService;
        this.appHooksService = appHooksService;
        this.columnsService = columnsService;
        this.tablesService = tablesService;
        this.columnsV3Service = columnsV3Service;
        this.logger = new _common.Logger(TablesV3Service.name);
    }
};
TablesV3Service = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _metadiffsservice.MetaDiffsService === "undefined" ? Object : _metadiffsservice.MetaDiffsService,
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService,
        typeof _columnsservice.ColumnsService === "undefined" ? Object : _columnsservice.ColumnsService,
        typeof _tablesservice.TablesService === "undefined" ? Object : _tablesservice.TablesService,
        typeof _columnsv3service.ColumnsV3Service === "undefined" ? Object : _columnsv3service.ColumnsV3Service
    ])
], TablesV3Service);
